
import AjaxPlugin from 'vux/src/plugins/ajax/index.js'
import Cell from 'vux/src/components/cell/index.vue'
import Group from 'vux/src/components/group/index.vue'
import Previewer from 'vux/src/components/previewer/index.vue'
import TransferDom from 'vux/src/directives/transfer-dom/index.js'
import XButton from 'vux/src/components/x-button/index.vue'
import XHeader from 'vux/src/components/x-header/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'


export default {
directives: {
TransferDom
},
components: {
XHeader,
XInput,
Group,
XButton,
Cell,
Previewer,
XTextarea
},
name: 'orderDetail',
data() {
return {
orderDetail: {},
arr: [],
fdetailList: [],
address: '',

flag: false,
solutionv: 1,
imgsrc: '',
options: {
getThumbBoundsFn(index) {
let thumbnail = document.querySelectorAll('.previewer-demo-img')[index];
let pageYScroll = window.pageYOffset || document.documentElement.scrollTop;
let rect = thumbnail.getBoundingClientRect();
return {x: rect.left, y: rect.top + pageYScroll, w: rect.width};
}
}
}
},
methods: {
bxjl() {
this.$router.push({name: 'makeMemo', params: {iden: 'EXPT', solutionv: this.solutionv, isHide: true}})
},
userevaluation() {
this.$router.push({name: 'userevaluation', params: {obj: this.orderDetail}})
},
show(index) {
this.$refs.previewer.show(index);
},
logIndexChange(arg) {
}
},
beforeRouteEnter(to, from, next) {
next(vm => {
var ind = vm.$route.params.index
let token = localStorage.getItem('token')
let opid = localStorage.getItem('userid')
var header = {
headers: {
token: token,
opid: opid
}
}
if (ind) {
vm.orderDetail = vm.$route.params.order
vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
vm.solutionv = vm.orderDetail.solutionv
var order = JSON.stringify(vm.orderDetail)
localStorage.setItem('order', order)
if (vm.orderDetail.rating) {
vm.flag = true
}
var arr = [], brr = [], index = 0;
if (vm.orderDetail.fdetail.content.length > 0) {
arr = vm.orderDetail.fdetail.content[0].path
var decrypt = function () {
AjaxPlugin.$http.get('api/v1/photos?path=' + arr[index]['origin'], header)
.then(res => {
brr.push({src: 'data:image/jpeg;base64,' + res.data.value});
index++
if (index < arr.length) {
decrypt()
}
})
}
decrypt()
vm.arr = brr
}
} else {
var order = localStorage.getItem('order')
vm.orderDetail = JSON.parse(order)

vm.address = vm.orderDetail.province + ' ' + vm.orderDetail.city + " " + vm.orderDetail.district
if (vm.orderDetail.rating) {
vm.flag = true
}
var arr = [], brr = [], index = 0;
if (vm.orderDetail.fdetail.content.length > 0) {
arr = vm.orderDetail.fdetail.content[0].path
var decrypt = function () {
AjaxPlugin.$http.get('api/v1/photos?path=' + arr[index]['origin'], header)
.then(res => {
brr.push({src: 'data:image/jpeg;base64,' + res.data.value});
index++
if (index < arr.length) {
decrypt()
}
})
}
decrypt()
vm.arr = brr
}

}

if (vm.orderDetail.isviwo) {
vm.orderDetail.isviwo = '是'
} else {
vm.orderDetail.isviwo = '否'
}
if (vm.orderDetail.sevenday) {
vm.orderDetail.sevenday = '是'
} else {
vm.orderDetail.sevenday = '否'
}
})
}
}



// WEBPACK FOOTER //
// ./src/components/detaillist.vue